import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import YouTubeIcon from "@mui/icons-material/YouTube";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import FeedbackIcon from "@mui/icons-material/Feedback";
import TelegramIcon from "@mui/icons-material/Telegram";
import "./css/Footer.css";
import StickyFooter from "./StickyFooter";
import IMAGES from "../../img/image";

const Footer = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { user } = useSelector((state) => state.user);
	return (
		<React.Fragment>
			<div className="container-fluid footer-container d-none d-md-none d-lg-block">
				<div className="row">
					<div className="col-12 col-sm-12 col-md-3 col-lg-3 mb-4">
						<div className="footer-logo">
							{/* <img src={IMAGES.logo} alt="" /> */}
							Coins<span>sup</span>
						</div>
						<span>
							<small>
								Welcome to Coinssup!
								<br />
								Experience India's leading platform for topping up in-game
								credits. Enjoy fast, hassle-free instant delivery with the
								assurance of 24/7 customer support.
							</small>
						</span>
						<br />
						<br />
						<p className="m-0 mt-2" style={{ color: `var(--t)` }}>
							SUPPORT
						</p>
						<span>+91 9727478250</span>
						<br />
						<span>coinssups@gmail.com</span>
					</div>
					<div className="px-lg-5 quick-links col-6 col-sm-6 col-md-3 col-lg-3 mb-4">
						<h6>Quick Links</h6>
						<hr />
						<ul>
							<li>
								<Link to="/">Home</Link>
							</li>
							{!user && (
								<>
									<li>
										<Link to="/login">Login</Link>
									</li>
									<li>
										<Link to="/register">Register</Link>
									</li>
								</>
							)}
							{user && (
								<>
									<li>
										<Link to="/wallet">Wallet</Link>
									</li>
									<li>
										<Link to="/orders">Orders</Link>
									</li>
									<li>
										<Link to="/user-dashboard">Dashboard</Link>
									</li>
								</>
							)}
							<li>
								<Link to="/support">Customer Support</Link>
							</li>
						</ul>
					</div>
					<div className="quick-links col-6 col-sm-6 col-md-3 col-lg-3 mb-4">
						<h6>Important Pages</h6>
						<hr />
						<ul>
							<li>
								<Link to="/privacy-policy">Privacy Policy</Link>
							</li>
							<li>
								<Link to="/terms">Terms & Conditions</Link>
							</li>
							<li>
								<Link to="/refund-policy">Refund Policy</Link>
							</li>
						</ul>
					</div>
					<div className="quick-links col-12 col-sm-12 col-md-3 col-lg-3 mb-4">
						<h6>Payment Modes</h6>
						<hr />
						<div className="payment-channels">
							<img src={IMAGES.phonepe} alt="" />
							<img src={IMAGES.gpay} alt="" />
							<img src={IMAGES.upi} alt="" />
						</div>
					</div>
					<hr />
					<span className="text-lg-center text-start">
						<small>All Rights Reserved © 2024 | COINSSUP</small>
					</span>
				</div>
			</div>
			{/* <StickyFooter /> */}
		</React.Fragment>
	);
};

export default Footer;
